import React from 'react';
import clsx from 'clsx';
import EntitiesErrorMessages from '@/components/errors/EntitiesErrorMessages';
import PanelContainer from '@/components/wrappers/PanelContainer';
import RequestAccessWizard from './RequestAccessWizard';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const RequestPanelContainerContent = ({
  category,
  className,
  code,
  children,
  compact,
  isNew,
  onChange,
  url,
}) => {
  const state = Selectors.useRequestPanelContainerContent({ category, code });
  const updateProperties = Events.useUpdateRequestProperties(category, { code });
  const content = isNew
    ? <RequestAccessWizard category={category} code={code} compact={compact} />
    : children;

  return (
    <PanelContainer
      canAccess={isNew ? state.canCreate : state.canRead}
      entity="request"
      exists={state.exists}
      isDirty={state.isDirty}
      isNew={isNew}
      name={state.name}
      onChange={onChange}
      readErrors={state.readErrors}
      readStatus={isNew ? [] : [state.readStatus, state.workflowReadStatus]}
      url={url}
    >
      <div className={clsx(className, isNew && 'panel-wizard')}>
        <EntitiesErrorMessages
          category={category}
          code={code}
          contexts={['fieldUUID']}
          entities={['request', 'server']}
          entity="request"
          errors={state.saveErrors}
          onDismiss={(errors) => updateProperties({ properties: { saveErrors: errors } })}
        />
        {content}
      </div>
    </PanelContainer>
  );
};

export default RequestPanelContainerContent;
